import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntAIPLevel: SelectDataObject[] = [
    { i: 0, t: 'Nicht zugeordnet', icon: 'mdi:remote', iconColor: 'text.secondary' },
    { i: 1, t: 'In Warteschlange', icon: 'mdi:remote', iconColor: 'error.main' },
    { i: 2, t: 'Wird gesendet...', icon: 'mdi:remote', iconColor: 'warning.main' },
    { i: 3, t: 'OK', icon: 'mdi:remote', iconColor: 'success.main' },
];
export default sIntAIPLevel;
